import { render, staticRenderFns } from "./BtnLgSecondary.vue?vue&type=template&id=43edc470&scoped=true"
import script from "./BtnLgSecondary.vue?vue&type=script&lang=js"
export * from "./BtnLgSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43edc470",
  null
  
)

export default component.exports